"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const vue_3 = require("vue");
const AsyncSearchInput_vue_1 = __importDefault(require("../Form/AsyncSearchInput/AsyncSearchInput.vue"));
const AsyncSearchInputOption_1 = __importDefault(require("../Form/AsyncSearchInput/AsyncSearchInputOption"));
const i18n_1 = require("../../common/i18n");
const ShopConfig_1 = require("../../common/utils/ShopConfig");
exports.default = (0, vue_1.defineComponent)({
    __name: 'LocationSelector',
    props: {
        id: {
            type: String,
            default: () => { var _a; return `location-selector-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ["zipCodeChange", "cityChange"],
    setup(__props, { emit }) {
        const props = __props;
        const zipCodeAsyncSearchInput = (0, vue_3.ref)(null);
        const cityAsyncSearchInput = (0, vue_3.ref)(null);
        const zipCodeOptions = (0, vue_3.ref)([]);
        const cityOptions = (0, vue_3.ref)([]);
        const locations = (0, vue_3.ref)([]);
        const getLocations = async (zipCode = '', city = '') => {
            const { url, token } = ShopConfig_1.ShopConfig.getLocationApiConnection();
            try {
                const response = await fetch(`${url}?zip=${zipCode}&city=${city}`, {
                    headers: {
                        'Authorization': `Basic ${token}`,
                        'Accept': 'application/json'
                    }
                });
                const data = await response.json();
                if (Array.isArray(data) && data.length > 0) {
                    locations.value = data;
                }
                else {
                    console.warn('No locations found for the given search criteria.');
                    locations.value = [];
                }
            }
            catch (error) {
                console.error(error.message);
            }
        };
        const computeZipOptions = () => {
            return locations.value.map((location) => {
                return new AsyncSearchInputOption_1.default(`${location.zip} - ${location.city}`, location.zip);
            });
        };
        const computeCityOptions = () => {
            return locations.value.map((location) => {
                return new AsyncSearchInputOption_1.default(`${location.zip} - ${location.city}`, location.city);
            });
        };
        const zipCodeSearchedValueChanged = async (zipCodeSearchedValue) => {
            await getLocations(zipCodeSearchedValue, "");
            zipCodeOptions.value = computeZipOptions();
            cityOptions.value = [];
        };
        const citySearchedValueChanged = async (citySearchedValue) => {
            await getLocations("", citySearchedValue);
            cityOptions.value = computeCityOptions();
            zipCodeOptions.value = [];
        };
        const zipCodeSelected = (value) => {
            var _a;
            let [zipCode, city] = value.label.split(" - ");
            emit("zipCodeChange", zipCode);
            emit("cityChange", city);
            (_a = cityAsyncSearchInput.value) === null || _a === void 0 ? void 0 : _a.setDisplayValue(city);
            zipCodeOptions.value = [];
            cityOptions.value = [];
        };
        const citySelected = (value) => {
            var _a;
            let [zipCode, city] = value.label.split(" - ");
            emit("zipCodeChange", zipCode);
            emit("cityChange", city);
            (_a = zipCodeAsyncSearchInput.value) === null || _a === void 0 ? void 0 : _a.setDisplayValue(zipCode);
            zipCodeOptions.value = [];
            cityOptions.value = [];
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                id: __props.id,
                class: "flex mb-3"
            }, [
                (0, vue_2.createVNode)(AsyncSearchInput_vue_1.default, {
                    ref_key: "zipCodeAsyncSearchInput",
                    ref: zipCodeAsyncSearchInput,
                    "placeholder-enable": true,
                    placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_zip', 'Zip', 'location_selector'),
                    options: zipCodeOptions.value,
                    "custom-class": "!w-[250px]",
                    class: "flex-[0_0_100px] mr-3",
                    required: true,
                    "max-length": 4,
                    "show-validity": true,
                    "display-value-after-selection": true,
                    "debounce-in-ms": 0,
                    onSearchedValueChanged: zipCodeSearchedValueChanged,
                    onSelected: zipCodeSelected,
                    onClose: _cache[0] || (_cache[0] = ($event) => (zipCodeOptions.value = []))
                }, null, 8, ["placeholder", "options"]),
                (0, vue_2.createVNode)(AsyncSearchInput_vue_1.default, {
                    ref_key: "cityAsyncSearchInput",
                    ref: cityAsyncSearchInput,
                    "placeholder-enable": true,
                    placeholder: (0, vue_2.unref)(i18n_1.trans)('shipping_address_custom_city', 'City', 'location_selector'),
                    options: cityOptions.value,
                    class: "grow",
                    required: true,
                    "show-validity": true,
                    "display-value-after-selection": true,
                    "debounce-in-ms": 0,
                    onSearchedValueChanged: citySearchedValueChanged,
                    onSelected: citySelected,
                    onClose: _cache[1] || (_cache[1] = ($event) => (cityOptions.value = []))
                }, null, 8, ["placeholder", "options"])
            ], 8, _hoisted_1));
        };
    }
});
